var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002649",
    d: "M6.333 2h4V1a1 1 0 1 1 2 0v1h1.5a1.5 1.5 0 0 1 1.5 1.5V6h-14V3.5a1.5 1.5 0 0 1 1.5-1.5h1.5V1a1 1 0 1 1 2 0v1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#002649",
    d: "M1.333 6h14v8.5a1.5 1.5 0 0 1-1.5 1.5h-11a1.5 1.5 0 0 1-1.5-1.5V6Zm2 3.5a.5.5 0 0 0 .5.5h1c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5h-1a.5.5 0 0 0-.5.5v1Zm4.5-1.5c-.275 0-.5.225-.5.5v1c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5h-1Zm3.5 1.5c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5v1Zm-7.5 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5h-1Zm3.5 1.5c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5v1Zm4.5-1.5c-.275 0-.5.225-.5.5v1c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5h-1Z",
    opacity: 0.4
  })));
};
export { SvgCalendar as ReactComponent };
export default __webpack_public_path__ + "c39e48b30edf645d7a4a15b890595329.svg";